/**
 * Browser pages only: whether a newer version is online than the one this page is running.
 * Compares the script files the server's newest page loads with the ones loaded here.
 */
// Written without browser types, because the cloud service also compiles this package.
const doc = (globalThis as { document?: { scripts: ArrayLike<{ src: string }> } }).document;

export async function newerVersionOnline(page: 'owner' | 'staff', apiBase = ''): Promise<boolean> {
  if (!doc) return false;
  try {
    const res = await fetch(`${apiBase}/api/version`, { cache: 'no-store' });
    if (!res.ok) return false;
    const latest = ((await res.json()) as Record<string, string[]>)[page] ?? [];
    const running = new Set(Array.from(doc.scripts, (s) => s.src.split('/').pop()).filter(Boolean));
    return latest.length > 0 && running.size > 0 && latest.some((name) => !running.has(name));
  } catch {
    return false;
  }
}
